module.exports = __webpack_public_path__ + "static/media/tour-operator.1cca8fac.svg";